import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import productData from '../product.json';

const Products = () => {
  const location = useLocation();
  const { title, subtitle, categories } = productData;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const pageSize = 5;

  useEffect(() => {
    setCurrentPage(1);
    setSelectedCategory('all');
  }, [location.pathname]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory]);

  const allProducts = categories.flatMap(category =>
    category.products.map(product => ({
      ...product,
      categoryName: category.name.zh,
      categoryId: category.id
    }))
  );
  
  // 根据选择的分类筛选产品
  const filteredProducts = selectedCategory === 'all' 
    ? allProducts 
    : allProducts.filter(product => product.categoryId === selectedCategory);
  
  // 计算总页数
  const totalPages = Math.ceil(filteredProducts.length / pageSize);
  
  // 使用pageIndex和pageSize计算当前页的产品
  const pageIndex = currentPage - 1;
  const startIndex = pageIndex * pageSize;
  const endIndex = startIndex + pageSize;
  const currentProducts = filteredProducts.slice(startIndex, endIndex);

  return (
    <main className="pt-[60px]">
      {/* Header */}
      <section className="py-16 bg-surface-bright">
        <div className="container mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{title.zh}</h1>
          <p className="text-on-surface-variant mb-8">{subtitle.zh}</p>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 bg-surface-container-low">
        <div className="container mx-auto px-6">
          {/* Category Filter */}
          <div className="flex flex-wrap gap-2 mb-6">
            <button 
              onClick={() => setSelectedCategory('all')}
              className={`px-3 py-1.5 rounded ${selectedCategory === 'all' ? 'bg-primary text-on-primary' : 'bg-surface text-on-surface-variant hover:bg-surface-variant'}`}
            >
              全部产品
            </button>
            {categories.map((category) => (
              <button 
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-3 py-1.5 rounded ${selectedCategory === category.id ? 'bg-primary text-on-primary' : 'bg-surface text-on-surface-variant hover:bg-surface-variant'}`}
              >
                {category.name.zh}
              </button>
            ))}
          </div>
          
          <div className="product-list space-y-12">
            {currentProducts.map((product, index) => (
              <Link 
                to={`/product/${product.id}`} 
                key={`${product.id}-${startIndex + index}`} 
                className="flex flex-col md:flex-row gap-8 group transition-all duration-300 hover:shadow-md p-4 rounded-lg hover:-translate-y-1"
              >
                <div className="flex-1">
                  <img 
                    src={product.image} 
                    alt={product.name.zh} 
                    className="w-full h-64 object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-on-surface mb-2 group-hover:text-primary transition-colors duration-300">{product.name.zh}</h3>
                      <h4 className="text-primary font-semibold mb-4">{product.categoryName}</h4>
                    </div>
                    <span className="text-sm text-on-surface-variant">{product.series}</span>
                  </div>
                  <p className="text-on-surface-variant mb-6">{product.description.zh}</p>
                  <div className="flex flex-wrap gap-2">
                    {product.applications.map((app, appIndex) => (
                      <span key={appIndex} className="px-3 py-1 bg-surface-container text-sm font-medium text-on-surface-variant rounded group-hover:bg-primary/10 group-hover:text-primary transition-colors duration-300">{app}</span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Pagination */}
      {totalPages > 1 && (
        <section className="py-8 bg-surface-container-low border-t border-gray-200">
          <div className="container mx-auto px-6">
            <div className="flex justify-center">
              <div className="flex space-x-2">
                {Array.from({ length: totalPages }, (_, index) => {
                  const pageNum = index + 1;
                  return (
                    <button 
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-4 py-2 rounded ${pageNum === currentPage ? 'bg-primary text-on-primary' : 'bg-surface text-on-surface-variant hover:bg-surface-variant'}`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      )}


    </main>
  );
};

export default Products;